export enum ModalsNames {
  getHelpModal = 'getHelpModal',
  editProfile = 'editProfile',

  editForm = 'editForm',
  deleteConfirmation = 'deleteConfirmation',

  ingredientCancelEdit = 'ingredientCancelEdit',
  ingredientCancelCreation = 'ingredientCancelCreation',
  ingredientDelete = 'ingredientDelete',
  ingredientRename = 'ingredientRename',
  ingredientWarning = 'ingredientWarning',
  ingredientInventoryAddAmount = 'ingredientInventoryAddAmount',
  ingredientInventoryCancelEdit = 'ingredientInventoryCancelEdit',
  ingredientSaveForm = 'ingredientSaveForm',
  createLocation = 'createLocation',

  orderCancelEdit = 'orderCancelEdit',
  orderDelete = 'orderDelete',
  orderNoUndeliveredIngredients = 'orderNoUndeliveredIngredients',
  orderReceiveModal = 'orderReceiveModal',

  premixCancelEdit = 'premixCancelEdit',
  premixCancelCreation = 'premixCancelCreation',
  premixDelete = 'premixDelete',
  premixCalculateDensity = 'premixCalculateDensity',
  removeIngredientFromPremix = 'removeIngredientFromPremix',
  premixRename = 'premixRename',

  recipeCancelEdit = 'recipeCancelEdit',
  recipeCancelCreation = 'recipeCancelCreation',
  recipeDelete = 'recipeDelete',
  recipeCalculateDensity = 'recipeCalculateDensity',
  removeIngredientFromRecipe = 'removeIngredientFromRecipe',
  recipeRename = 'recipeRename',
  recipeDuplicate = 'recipeDuplicate',
  recipeChangeMethodWarning = 'recipeChangeMethodWarning',
  recipeDeleteTransitionDay = 'recipeDeleteTransitionDay',
  refusalsModal = 'refusalsModal',
  refusalsSettingsModal = 'refusalsSettingsModal',
  recipeFixedDateTransitionModal = 'recipeFixedDateTransitionModal',

  transfersModal = 'transfersModal',
  transfersHistoryModal = 'transfersHistoryModal',

  groupCancelCreation = 'groupCancelCreation',
  groupCancelEdit = 'groupCancelEdit',
  groupTypeCreation = 'groupTypeCreation',
  feedingListEditTableFormModal = 'feedingListEditTableFormModal',
  feedingListItemRemove = 'feedingListItemRemove',
  feedingListItemSplit = 'feedingListItemSplit',
  feedingListTableModal = 'feedingListTableModal',

  addIngredientCancelCreation = 'addIngredientCancelCreation',
  groupDeleteConfirm = 'groupDeleteConfirm',
  deleteFeedingModal = 'deleteFeedingModal',
  createFeedingModal = 'createFeedingModal',
  editFeedingModal = 'editFeedingModal',
  editScheduledGroupRecipeModal = 'editScheduledGroupRecipeModal',
  editGroupHeadCount = 'editGroupHeadCount',
  editGroupGlobalFeeding = 'editGroupGlobalFeeding',

  mixerDeleteConfirm = 'mixerDeleteConfirm',
  mixerCancelCreation = 'mixerCancelCreation',
  mixerCancelEdit = 'mixerCancelEdit',
  deleteScheduledPremix = 'deleteScheduledPremix',
  deleteScheduledRecipe = 'deleteScheduledRecipe',

  zoneModal = 'zoneModal',

  wizardModal = 'wizardModal',

  downloadIngredientsList = 'downloadIngredientsList',
  downloadPremixesList = 'downloadPremixesList',
  downloadRecipesList = 'downloadRecipesList',
  downloadGroupsList = 'downloadGroupsList',
  downloadLoadMixersListByLoads = 'downloadLoadMixersListByLoads',
  downloadLoadMixersListByList = 'downloadLoadMixersListByList',
  downloadLotsList = 'downloadLotsList',

  newSharing = 'newSharing',
  editInvitation = 'editInvitation',
  leaveInvitation = 'leaveInvitation',
  removePartner = 'removePartner',

  confirm = 'confirm',

  createOperatorModal = 'createOperatorModal',
  operatorModal = 'operatorModal', // TODO edit
  editTapOperatorModal = 'editTapOperatorModal', // TODO edit

  priceCreationModal = 'priceCreationModal',
  milkPriceCreationModal = 'milkPriceCreationModal',

  relationCreationModal = 'relationCreationModal',

  lotTypeCreationModal = 'lotTypeCreationModal',
  dateDeliveriesModal = 'dateDeliveriesModal',
  costTypeCreationModal = 'costTypeCreationModal',
  costTypeNewDateModal = 'costTypeNewDateModal',
  dateCostsModal = 'dateCostsModal',
  createFeedingPeriodModal = 'createFeedingPeriodModal',

  herdManagementCreation = 'herdManagementCreation',

  textAreaModal = 'textAreaModal',

  resetFarmModal = 'resetFarmModal',

  deleteFeedingPremixModal = 'deleteFeedingPremixModal',
  cancelPremixSchedule = 'cancelPremixSchedule',

  cancelCloseoutEdit = 'cancelCloseoutEdit',

  cancelLotEdit = 'cancelLotEdit',
  deleteLotModal = 'deleteLotModal',
  cancelNotesEdit = 'cancelNotesEdit',
  cancelAddLotCost = 'cancelAddLotCost',
  cancelAddPenCost = 'cancelAddPenCost',

  noteModal = 'noteModal',

  downloadReportModal = 'downloadReportModal',

  stockTransactionsSettingsModal = 'stockTransactionsSettingsModal',
  deleteOrderReceiveModal = 'deleteOrderReceiveModal',
  selectMatchedIngredientModal = 'selectMatchedIngredientModal',
  selectReceiveOptionModal = 'selectReceiveOptionModal',

  deleteBatchModal = 'deleteBatchModal',
  pdfPreviewModal = 'pdfPreviewModal',
  uploadFileModal = 'uploadFileModal',

  editScoreModal = 'editScoreModal',

  bunkReaderModal = 'bunkReaderModal',
  bunkReaderNotesModal = 'bunkReaderNotesModal',
}
